import React, { Component } from 'react';
import { Row, Col, Typography, Spin, Layout, Space, message, Card, List, Tag } from 'antd'
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import Logged, { User } from "../../../Hooks/Logged";
import FloatingButton from "../../Widgets/Floating Button/FloatingButton";

// import ModalQuotations from './ModalQuotations'
import { ButtonView } from '../../Widgets/Buttons';
import PageHeader from '../../Widgets/PageHeader/PageHeader';
import dayjs from 'dayjs';


const { Content } = Layout;
const { Text, Title } = Typography

/**
 *
 *
 * @export
 * @class Quotations
 * @extends {Component}
 * @description Vista donde se listan todos los quotations
 */
class Quotations extends Component {
    static contextType = Logged;

    /**
     *Creates an instance of Quotations.
     * @param {*} props
     * @memberof Quotations
     */
    constructor(props) {
        super(props)
        this.state = {

            loading: false,
            quotations: {
                data: [],
                limit: 10,
                page: 1,
                total: 0,
                pages: 0,
                filters: []
            }
        }
    }

    componentDidMount() {

        this.get()
    }

    componentDidUpdate(prevProps) {
        if (this.props.search != prevProps.search) {
            this.get()
        }
    }

    /**
    *
    * @memberof Quotations
    * @method get
    * @description Obtiene la lista de quotations
    */
    get = async ({
        page = this.state.quotations.page,
        limit = this.state.quotations.limit,
        search = this.props.search,
    } = this.state.quotations) => {

        this.setState({ loading: true })
        axios.get('/customer/cotizaciones', {
            params: {
                limit,
                page,
                search
            }
        })
            .then(({ data }) => {
                this.setState({ quotations: data })
            })
            .catch(res => {
                console.log("res", res);
                message.error(res.response?.data?.message ?? "Error")
            })
            .finally(() => this.setState({ loading: false }))
    }




    render() {

        return (
            <>
                <Spin spinning={this.state.loading}>
                    <PageHeader
                        className="admin-page-header"
                        title="Quotations"
                    >

                    </PageHeader>

                    <Content className="quotations-content content-bg pd-1">
                        <List
                            className="component-list"
                            itemLayout="horizontal"
                            locale={{ emptyText: "Quotations sin registros" }}
                            dataSource={this.state.quotations.data}
                            pagination={{
                                current: this.state.quotations.page,
                                pageSize: this.state.quotations.limit,
                                total: this.state.quotations.total,
                                hideOnSinglePage: false,
                                position: 'bottom',
                                onChange: (page, limit) => this.get({ page, limit })

                            }}

                            renderItem={item => (
                                <List.Item className="component-list-item">
                                    <Card className="card-list">
                                        <Row className="width-100" gutter={[8, 8]}>
                                            <Col xs={12} md={3}>
                                                <Text strong ellipsis>{dayjs(item.createdAt).format("DD-MM-YYYY")}</Text>
                                            </Col>
                                            <Col xs={12} md={5}>
                                                <Text ellipsis>{"{{Descripcion}}"}</Text>
                                            </Col>
                                            <Col xs={12} md={5} className="center">
                                                <Text ellipsis>{"{{Servicio}}"}</Text>
                                            </Col>
                                            <Col xs={12} md={3} className="center">
                                                <Tag>{"{{Color}}"}</Tag>
                                            </Col>
                                            <Col xs={12} md={5} className="center">
                                                <Text ellipsis>{"{{Costo}}"}</Text>
                                            </Col>
                                            <Col xs={12} md={3} className="flex-right">
                                                <Space>
                                                    <ButtonView

                                                        onClick={() => this.props.navigate('/customer/quotations/' + item._id)}
                                                    />

                                                </Space>
                                            </Col>
                                        </Row>
                                    </Card>
                                </List.Item>
                            )}
                        />
                    </Content>

                    <FloatingButton title="Nueva Cotizacion" onClick={() => this.setState({ modalCotizacion: true })} />

                    
                </Spin>
            </>
        )
    }
}

export default function (props) {

    const user = React.useContext(User)

    return <Quotations {...props} navigate={useNavigate()} />
}